// The day an access row names, in the words the prototype uses.
//
// ONE FORMATTER FOR THE WHOLE ROW, because the line under the name, the reason
// where the draft would have been, and the confirm all talk about the same
// instant — and "expired Wed 3 Sep" two inches above "revoked 2 Sep" is the
// kind of disagreement nobody notices until a customer is on the phone.

const WEEKDAYS_ABBR = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const MONTHS_ABBR = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const two = (n: number) => String(n).padStart(2, '0');

/**
 * `today 09:16` on the day itself, `Thu 10 Sep` otherwise.
 *
 * The clock only appears on the same day because that is the only day a time
 * tells Patricia anything — "signed in today 09:16" is a fact about this
 * morning; "signed in 14 Aug 11:42" is noise around a date.
 *
 * Rendered in the BROWSER's local zone, which at this desk is Dublin's. A stay
 * date is a business day and goes through `@bbbk/schema`'s business-day rules;
 * this is a wall-clock moment a person is looking at, and the two are different
 * questions.
 */
export function accessDateLabel(iso: string | null, now: Date = new Date()): string {
  if (!iso) return '';
  const at = new Date(iso);
  if (Number.isNaN(at.getTime())) return '';
  const sameDay =
    at.getFullYear() === now.getFullYear() &&
    at.getMonth() === now.getMonth() &&
    at.getDate() === now.getDate();
  if (sameDay) return `today ${two(at.getHours())}:${two(at.getMinutes())}`;
  return `${WEEKDAYS_ABBR[at.getDay()]} ${at.getDate()} ${MONTHS_ABBR[at.getMonth()]}`;
}

/**
 * `3 Sep` — the shorter form the dead-link reason uses.
 *
 * A reason is a sentence rather than a label, and a weekday inside one reads as
 * clutter: *This link expired on 3 Sep* says everything *on Wed 3 Sep* does.
 */
export function accessDayLabel(iso: string | null): string {
  if (!iso) return '';
  const at = new Date(iso);
  if (Number.isNaN(at.getTime())) return '';
  return `${at.getDate()} ${MONTHS_ABBR[at.getMonth()]}`;
}
